/* ==========================================================================
   FlatWine — recommendations.js
   Carga el HTML de product-recommendations vía Section Rendering.
   Si no hay productos, oculta el bloque en público.
   ========================================================================== */

(function () {
  'use strict';

  /* Cargado por cada sección que lo necesita; dos etiquetas del mismo src
     se ejecutan dos veces. Sin la guarda, los listeners se duplicaban. */
  if (window.__fw_recommendations) return;
  window.__fw_recommendations = true;

  function hide(node) {
    node.classList.remove('product-recs-host--pending');
    node.setAttribute('hidden', '');
    node.setAttribute('data-recommendations-empty', '');
  }

  function load(root) {
    var url = root.getAttribute('data-url');
    if (!url) {
      hide(root);
      return;
    }

    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('recs-failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-product-recommendations]');
        var grid = incoming && incoming.querySelector('[data-product-recommendations-grid]');
        /* La sección solo emite la rejilla DENTRO de su {% if has_recs %}. O
           sea: sin recomendaciones llega el contenedor pero no la rejilla, que
           es el caso legítimo y frecuente. Antes eso se registraba como
           «marcado roto», así que cada producto sin recomendaciones llenaba la
           consola con un error y una regresión de verdad quedaba indistinguible
           del funcionamiento normal. El único fallo real es que no llegue ni el
           contenedor. */
        if (!incoming) {
          console.error('[recs] la respuesta no trae el contenedor esperado', url);
          hide(root);
          return;
        }
        if (!grid || !grid.children.length) {
          hide(root);
          return;
        }
        incoming.classList.remove('product-recs-host--pending');
        root.replaceWith(incoming);
        /* El marcado que acaba de entrar trae [data-reveal] y [data-kinetic],
           y motion.js junta esos nodos una sola vez al arrancar. Sin hidratar,
           el bloque entero se quedaba en opacity:0 para siempre: ocupaba su
           altura, empujaba el pie hacia abajo, y ni el título ni las tarjetas
           se veían. */
        if (window.fwMotion && typeof window.fwMotion.hydrate === 'function') {
          window.fwMotion.hydrate(incoming);
        } else {
          console.error('[recs] motion.js no está disponible; el bloque quedaría invisible');
          incoming.querySelectorAll('[data-reveal]').forEach(function (el) {
            el.classList.add('is-revealed');
          });
        }
      })
      .catch(function (err) {
        console.error('[recs] no se pudieron cargar', url, err);
        hide(root);
      });
  }

  function observe(root) {
    if (root.querySelector('[data-product-recommendations-grid]')) return;

    if (!('IntersectionObserver' in window)) {
      load(root);
      return;
    }

    var observer = new IntersectionObserver(function (entries, current) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        current.unobserve(entry.target);
        load(entry.target);
      });
    }, { rootMargin: '0px 0px 280px 0px' });

    observer.observe(root);
  }

  function boot() {
    document.querySelectorAll('[data-product-recommendations]').forEach(observe);
  }

  window.fwRecommendations = {
    refresh: function (root) {
      if (root) {
        load(root);
        return;
      }
      document.querySelectorAll('[data-product-recommendations]').forEach(load);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Era el único de los seis guiones del tema sin este manejador. Al cambiar
     «Cantidad de productos» o el título desde el editor, Shopify reemplaza el
     HTML de la sección; boot() no volvía a correr y el bloque se quedaba como
     un contenedor pendiente de un pixel. El cliente veía que la sección
     desapareció y concluía que estaba rota. */
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-product-recommendations]').forEach(observe);
  });
})();
